import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./styles/Home.css";
import PopupTranslate from "./PopupTranslate";

const Home = () => {
  const [email, setEmail] = useState("");
  const [isChecked, setIsChecked] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [articles, setArticles] = useState([]); // Initialisation de l'état vide pour les articles
  const URL_FORM_BREVO = process.env.REACT_APP_URL_FORM_BREVO;


  useEffect(() => {
    const REACT_APP_URL_CORS = process.env.REACT_APP_URL_CORS;
   
    if (!REACT_APP_URL_CORS) {
      console.error(
        "Erreur: La variable d'environnement BACKEND_URL est indéfinie."
      );
      return;
    }

    fetch(`${REACT_APP_URL_CORS}/api/articles`)
      .then((response) => response.json())
      .then((data) => setArticles(data))
      .catch((error) =>
        console.error("Erreur lors du chargement des articles:", error)
      );
  });

  // 🔍 Filtrer les articles en fonction de la recherche
  const filteredArticles = articles.filter(
    (article) =>
      article.title &&
      article.theme &&
      (article.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
        article.theme.toLowerCase().includes(searchTerm.toLowerCase()))
  );

  const handleClearFilters = () => setSearchTerm("");

  return (
    <div className="container">
      <PopupTranslate />
      {/* Logo et titre principal */}
      <div className="centered-text">
        <div>
          <img
            src={require("../assets/logosansslogan.png")}
            alt="Weekly Cyber Logo"
            style={{ height: "200px", width: "auto" }}
          />
          <h1>Weekly Cybersecurity Info</h1>

          {/* Formulaire d'abonnement à la newsletter */}
          <div className="newsletter-container">
            <h6>Get the latest updates and insights directly in your inbox.</h6>
            <form
              name="newsletter"
              className="newsletter-form"
              id="sib-form"
              method="POST"
              action={URL_FORM_BREVO}
              data-type="subscription"
              target="_blank"
            >
              <div className="form-group">
                <input
                  type="email"
                  className="form-control"
                  name="EMAIL"
                  placeholder="Enter your email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>

              <div className="form-check">
                <input
                  type="checkbox"
                  className="form-check-input"
                  id="termsCheckbox"
                  name="OPT_IN"
                  checked={isChecked}
                  onChange={(e) => setIsChecked(e.target.checked)}
                  required
                />
                <label className="form-check-label" htmlFor="termsCheckbox">
                  I agree to receive your emails and confirm that I have read
                  your <a href="/privacy-policy">privacy policy</a> and{" "}
                  <a href="/terms-of-use">terms of use</a>.
                </label>
              </div>

              {/* Note sur Brevo */}
              <div className="brevo-notice">
                We use Brevo as our marketing platform. By submitting this form,
                you consent to having the personal data you provided transferred
                to Brevo for processing in accordance with their{" "}
                <a href="https://www.brevo.com/fr/legal/privacypolicy/">
                  privacy policy
                </a>
                .
              </div>
              <button type="submit" className="btn btn-primary mt-2 mb-3">
                Subscribe
              </button>
            </form>
          </div>
        </div>
      </div>

      {/* Section des articles en vedette */}
      <h3 className="section-title">Featured Posts</h3>
      <div className="d-flex flex-wrap justify-content-center">
        {articles.slice(0, 3).map((article, index) => (
          <div
            key={index}
            className="card custom-card m-3"
            style={{ width: "18rem" }}
          >
            <img
              src={`/${article.image}`}
              className="card-img-top"
              alt={article.title_card}
            />
            <div className="card-body">
              <Link
                to={`/article/${article.id}`}
                style={{ textDecoration: "none", color: "black" }}
              >
                <h5 className="card-title_card">{article.title_card}</h5>
              </Link>
              <h6 className="card-subtitle text-muted">{article.theme}</h6>
              <p className="card-text">{article.description}</p>
            </div>
          </div>
        ))}
      </div>

      {/* Section d'archives avec barre de recherche */}
      <h3 className="section-title">Archive</h3>
      <div className="search-bar-container">
        <div className="search-wrapper">
          <span className="search-icon">
            <i className="fas fa-search"></i>
          </span>
          <input
            type="text"
            placeholder="Search Posts by Title or Theme..."
            className="form-control search-input"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
      </div>

      {/* Affichage des articles filtrés */}
      {filteredArticles.length > 0 ? (
        <div className="d-flex flex-wrap justify-content-center">
          {filteredArticles.map((article, index) => (
            <div
              key={index}
              className="card custom-card m-3"
              style={{ width: "18rem" }}
            >
              <img
                src={`/${article.image}`}
                className="card-img-top"
                alt={article.title}
              />
              <div className="card-body">
                <Link
                  to={`/article/${article.id}`}
                  style={{ textDecoration: "none", color: "black" }}
                >
                  <h5 className="card-title">{article.title}</h5>
                </Link>
                <h6 className="card-subtitle text-muted">{article.theme}</h6>
                <p className="card-text">{article.description}</p>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="no-results">
          <p>No Posts found</p>
          <button className="btn btn-secondary" onClick={handleClearFilters}>
            Clear Filters
          </button>
        </div>
      )}
    </div>
  );
};

export default Home;
